/* Ginna B Studio — theme.js */
(function () {
  'use strict';

  // --- Mobile menu toggle ---
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-menu-toggle]');
    var close = e.target.closest('[data-mobile-menu-close]');
    var menu = document.querySelector('.mobile-menu');
    if (toggle && menu) { menu.classList.add('open'); }
    if (close && menu) { menu.classList.remove('open'); }
  });

  // --- Countdown timer ---
  function tick() {
    var els = document.querySelectorAll('[data-countdown]');
    els.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-countdown'), 10);
      if (isNaN(target)) return;
      var now = Math.floor(Date.now() / 1000);
      var diff = target - now;
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var d_el = el.querySelector('[data-cd-d]');
      var h_el = el.querySelector('[data-cd-h]');
      var m_el = el.querySelector('[data-cd-m]');
      var s_el = el.querySelector('[data-cd-s]');
      if (d_el) d_el.textContent = pad(d);
      if (h_el) h_el.textContent = pad(h);
      if (m_el) m_el.textContent = pad(m);
      if (s_el) s_el.textContent = pad(s);
      var mini = el.querySelector('[data-cd-mini]');
      if (mini) mini.textContent = pad(d) + ' dage · ' + pad(h) + ' timer · ' + pad(m) + ' min · ' + pad(s) + ' sek';
    });
  }
  setInterval(tick, 1000);
  tick();

  // --- Product image swap ---
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-product-main-image]');
    var src = thumb.getAttribute('data-src');
    if (main && src) main.setAttribute('src', src);
  });
})();
